<div mat-dialog-content>
  <h3 class="text label-header-text">
    Prodscoutlog Db search results:
  </h3>
  @for (log of data | sort: 'name'; track log) {
    <div class="cub text label-text item-card">
      <div (click)="navigateLog(log)">
        {{ log.name }}
        @if (log.modelNumber) {
          <p
            class="text small-text" style="color: green; position: inherit; float: right;">
          {{log.modelNumber}}</p>
        } @else {
          <p class="text small-text" style="color: red;  position: inherit; float: right;">
            Model Number Not Found
          </p>
        }
        <p class="text label-text" style="right: 2vw;
        top: 2vh;">
          {{ log.time | date: "yyyy-MM-dd HH:mm:ss a" }}
        </p>
      </div>
      <div>
        <hr>
          <h6 class="text label-text">
            Sensors tested with Device:
          </h6>
          @for (sensor of log.sensors; track sensor) {
            <p class="text small-text"
              [ngStyle]="{'color': !sensor.testSensor? 'green' : 'red'}" style="padding-left: 15px">
              - {{ sensor.name }}
            </p>
          }
        </div>
      </div>
    }
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button class="close" (click)="onNoClick()" color="primary">Okay</button>
  </div>